import React, { PropsWithChildren } from 'react'

import { I18nextProvider } from 'react-i18next'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'

import { ApolloProviderWithNavigation } from '@/apollo/apollo-provider-with-navigation'
import { ErrorRedirect } from '@/components/error-redirect'
import { Notifications } from '@/components/notifications'
import { GlobalModalProvider } from '@/context/global-modal-context'
import { NavigationProvider } from '@/context/navigation-context'
import { GlobalStyle, theme } from '@/styles'
import i18n from '@/translations/i18n'

const AppProviders = ({ children }: PropsWithChildren) => (
  <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
    <NavigationProvider>
      <ErrorRedirect />
      <ApolloProviderWithNavigation>
        <ThemeProvider theme={theme}>
          <GlobalModalProvider>
            <GlobalStyle />
            <I18nextProvider i18n={i18n}>{children}</I18nextProvider>
            <Notifications />
          </GlobalModalProvider>
        </ThemeProvider>
      </ApolloProviderWithNavigation>
    </NavigationProvider>
  </BrowserRouter>
)

export { AppProviders }
